<template>
  <div>
    <p style="font-size: 16px;font-weight: bold;margin-left: 10px">常见问题</p>
    <div>
      <van-cell is-link v-for="(item,index) in list" :key="index"
                @click="linkTo(item)">
        <template slot="title">
          <span class="custom-text"><i class="iconfont iconplay" style="font-size: 12px"> </i> {{ item.Name }}</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {
  name: 'help',
  data() {
    return {
      list: []
    }
  },
  components: {},
  methods: {
    getMemberArticle() {
      const params = {
        Type: '常见问题'
      }
      this.$post('/BizMemberArticle/AllList', params).then(res => {
        if (res) {
          this.list = res.Data
        }
      })
    },
    linkTo(item) {
      this.$router.replace({path: '/article/articleDetail', query: {Id: item.Id, backUrl: 'help', backQuery: JSON.stringify({backUrl: 'user'})}})
    }
  },
  mounted() {
    this.getMemberArticle()
  }
}
</script>

<style scoped>

</style>
